const courseOne = {
  material: {
    totalDuration: 'PT14H58M56S',
    weeks: [
      {
        name: 'Data Connectivity With Power BI',
        totalDuration: 'PT5H11M1S',
        assessments: [
          {
            typeName: 'ASSIGNMENT',
          },
          {
            typeName: 'ASSIGNMENT',
          },
        ],
        lectures: [
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
        ],
      },
      {
        name: 'Clean Your Data',
        totalDuration: 'PT5H56M5S',
        assessments: [
          {
            typeName: 'ASSIGNMENT',
          },
          {
            typeName: 'ASSIGNMENT',
          },
          {
            typeName: 'ASSIGNMENT',
          },
          {
            typeName: 'ASSIGNMENT',
          },
          {
            typeName: 'UNGRADED_LAB',
          },
          {
            typeName: 'UNGRADED_LAB',
          },
          {
            typeName: 'UNGRADED_LAB',
          },
          {
            typeName: 'UNGRADED_LAB',
          },
          {
            typeName: 'UNGRADED_LAB',
          },
          {
            typeName: 'PLUGIN',
          },
          {
            typeName: 'PLUGIN',
          },
        ],
        lectures: [
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/6b/7dddea1b364f6a816dfc53891e6d14/160x60_Google.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/6b/7dddea1b364f6a816dfc53891e6d14/160x60_Google.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/6b/7dddea1b364f6a816dfc53891e6d14/160x60_Google.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/6b/7dddea1b364f6a816dfc53891e6d14/160x60_Google.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/6b/7dddea1b364f6a816dfc53891e6d14/160x60_Google.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/6b/7dddea1b364f6a816dfc53891e6d14/160x60_Google.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/6b/7dddea1b364f6a816dfc53891e6d14/160x60_Google.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/6b/7dddea1b364f6a816dfc53891e6d14/160x60_Google.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/6b/7dddea1b364f6a816dfc53891e6d14/160x60_Google.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/6b/7dddea1b364f6a816dfc53891e6d14/160x60_Google.png',
              },
            ],
          },
        ],
      },
      {
        name: 'Verify and Report on Cleaning Results',
        totalDuration: 'PT1H40M5S',
        assessments: [
          {
            typeName: 'ASSIGNMENT',
          },
          {
            typeName: 'ASSIGNMENT',
          },
          {
            typeName: 'ASSIGNMENT',
          },
        ],
        lectures: [
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/6b/7dddea1b364f6a816dfc53891e6d14/160x60_Google.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/6b/7dddea1b364f6a816dfc53891e6d14/160x60_Google.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/6b/7dddea1b364f6a816dfc53891e6d14/160x60_Google.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/6b/7dddea1b364f6a816dfc53891e6d14/160x60_Google.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/6b/7dddea1b364f6a816dfc53891e6d14/160x60_Google.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/6b/7dddea1b364f6a816dfc53891e6d14/160x60_Google.png',
              },
            ],
          },
        ],
      },
      {
        name: 'Reading Data in Python',
        totalDuration: 'PT1H11M45S',
        assessments: [
          {
            typeName: 'ASSIGNMENT',
          },
          {
            typeName: 'ASSIGNMENT',
          },
        ],
        lectures: [
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/1f/3d4481024a4338b4077beb75b62612/new-1-UCSanDiego-Coursera-wide-2-.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/1f/3d4481024a4338b4077beb75b62612/new-1-UCSanDiego-Coursera-wide-2-.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/1f/3d4481024a4338b4077beb75b62612/new-1-UCSanDiego-Coursera-wide-2-.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/1f/3d4481024a4338b4077beb75b62612/new-1-UCSanDiego-Coursera-wide-2-.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/1f/3d4481024a4338b4077beb75b62612/new-1-UCSanDiego-Coursera-wide-2-.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/1f/3d4481024a4338b4077beb75b62612/new-1-UCSanDiego-Coursera-wide-2-.png',
              },
            ],
          },
        ],
      },
      {
        name: 'Skill Assessment',
        totalDuration: 'PT1H',
        assessments: [
          {
            typeName: 'ASSIGNMENT',
          },
        ],
        lectures: null,
      },
    ],
  },
  instructors: [
    {
      id: '185939614',
      coursesTaught: 43,
      department: '',
      fullName: 'Professionals from the Industry',
      isTopInstructor: null,
      learnersReached: 13043,
      photo:
        'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/https://coursera-instructor-photos.s3.amazonaws.com/83/b4728947fa4257a6dcdd56b36db0b1/Screenshot-2025-06-25-at-2.41.43-PM-1-.jpg',
      shortName: '',
      title: '',
      website: null,
    },
  ],
};

const courseTwo = {
  material: {
    totalDuration: 'PT9H44M56S',
    weeks: [
      {
        name: ' Data Types and Structures',
        totalDuration: 'PT3H29M19S',
        assessments: [
          {
            typeName: 'ASSIGNMENT',
          },
          {
            typeName: 'ASSIGNMENT',
          },
          {
            typeName: 'ASSIGNMENT',
          },
          {
            typeName: 'ASSIGNMENT',
          },
          {
            typeName: 'ASSIGNMENT',
          },
          {
            typeName: 'PLUGIN',
          },
        ],
        lectures: [
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/6b/7dddea1b364f6a816dfc53891e6d14/160x60_Google.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/6b/7dddea1b364f6a816dfc53891e6d14/160x60_Google.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/6b/7dddea1b364f6a816dfc53891e6d14/160x60_Google.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/6b/7dddea1b364f6a816dfc53891e6d14/160x60_Google.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/6b/7dddea1b364f6a816dfc53891e6d14/160x60_Google.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/6b/7dddea1b364f6a816dfc53891e6d14/160x60_Google.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/6b/7dddea1b364f6a816dfc53891e6d14/160x60_Google.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/6b/7dddea1b364f6a816dfc53891e6d14/160x60_Google.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/6b/7dddea1b364f6a816dfc53891e6d14/160x60_Google.png',
              },
            ],
          },
        ],
      },
      {
        name: 'Introduction to (Exploratory Data Analysis) EDA',
        totalDuration: 'PT3H5M20S',
        assessments: [
          {
            typeName: 'ASSIGNMENT',
          },
          {
            typeName: 'ASSIGNMENT',
          },
          {
            typeName: 'ASSIGNMENT',
          },
        ],
        lectures: [
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
        ],
      },
      {
        name: 'Data Wrangling',
        totalDuration: 'PT49M47S',
        assessments: [
          {
            typeName: 'ASSIGNMENT',
          },
          {
            typeName: 'PLUGIN',
          },
        ],
        lectures: [
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/54/a2cad57ff54d7ca2b771edc7572b46/IBM-Logo-Blk.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/54/a2cad57ff54d7ca2b771edc7572b46/IBM-Logo-Blk.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/54/a2cad57ff54d7ca2b771edc7572b46/IBM-Logo-Blk.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/54/a2cad57ff54d7ca2b771edc7572b46/IBM-Logo-Blk.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/54/a2cad57ff54d7ca2b771edc7572b46/IBM-Logo-Blk.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/54/a2cad57ff54d7ca2b771edc7572b46/IBM-Logo-Blk.png',
              },
            ],
          },
        ],
      },
      {
        name: 'Pandas',
        totalDuration: 'PT1H20M30S',
        assessments: [
          {
            typeName: 'PLUGIN',
          },
        ],
        lectures: [
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/32/22df5a8c3c4ada85761096fa8159cf/2.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/32/22df5a8c3c4ada85761096fa8159cf/2.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/32/22df5a8c3c4ada85761096fa8159cf/2.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/32/22df5a8c3c4ada85761096fa8159cf/2.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/32/22df5a8c3c4ada85761096fa8159cf/2.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/32/22df5a8c3c4ada85761096fa8159cf/2.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/32/22df5a8c3c4ada85761096fa8159cf/2.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/32/22df5a8c3c4ada85761096fa8159cf/2.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/32/22df5a8c3c4ada85761096fa8159cf/2.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/32/22df5a8c3c4ada85761096fa8159cf/2.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/32/22df5a8c3c4ada85761096fa8159cf/2.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/32/22df5a8c3c4ada85761096fa8159cf/2.png',
              },
            ],
          },
        ],
      },
      {
        name: 'Skill Assessment',
        totalDuration: 'PT1H',
        assessments: [
          {
            typeName: 'ASSIGNMENT',
          },
        ],
        lectures: null,
      },
    ],
  },
  instructors: [
    {
      id: '185939614',
      coursesTaught: 43,
      department: '',
      fullName: 'Professionals from the Industry',
      isTopInstructor: null,
      learnersReached: 13043,
      photo:
        'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/https://coursera-instructor-photos.s3.amazonaws.com/83/b4728947fa4257a6dcdd56b36db0b1/Screenshot-2025-06-25-at-2.41.43-PM-1-.jpg',
      shortName: '',
      title: '',
      website: null,
    },
  ],
};

const courseThree = {
  material: {
    totalDuration: 'PT11H6M42S',
    weeks: [
      {
        name: 'Data and Information',
        totalDuration: 'PT1H23M34S',
        assessments: [
          {
            typeName: 'ASSIGNMENT',
          },
          {
            typeName: 'ASSIGNMENT',
          },
          {
            typeName: 'ASSIGNMENT',
          },
        ],
        lectures: [
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
        ],
      },
      {
        name: 'GroupBy',
        totalDuration: 'PT36M47S',
        assessments: null,
        lectures: [
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/32/22df5a8c3c4ada85761096fa8159cf/2.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/32/22df5a8c3c4ada85761096fa8159cf/2.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/32/22df5a8c3c4ada85761096fa8159cf/2.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/32/22df5a8c3c4ada85761096fa8159cf/2.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/32/22df5a8c3c4ada85761096fa8159cf/2.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/32/22df5a8c3c4ada85761096fa8159cf/2.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/32/22df5a8c3c4ada85761096fa8159cf/2.png',
              },
            ],
          },
        ],
      },
      {
        name: 'Introduction to (Exploratory Data Analysis) EDA',
        totalDuration: 'PT3H5M20S',
        assessments: [
          {
            typeName: 'ASSIGNMENT',
          },
          {
            typeName: 'ASSIGNMENT',
          },
          {
            typeName: 'ASSIGNMENT',
          },
        ],
        lectures: [
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
        ],
      },
      {
        name: 'Data Connectivity with Power BI',
        totalDuration: 'PT5H1M1S',
        assessments: [
          {
            typeName: 'ASSIGNMENT',
          },
          {
            typeName: 'ASSIGNMENT',
          },
        ],
        lectures: [
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
          {
            partners: [
              {
                logo: 'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/http://coursera-university-assets.s3.amazonaws.com/55/67f4887ffe46bf93ce6a4e44db3279/Partner-Front-and-Course-Logo.png',
              },
            ],
          },
        ],
      },
      {
        name: 'Skill Assessment',
        totalDuration: 'PT1H',
        assessments: [
          {
            typeName: 'ASSIGNMENT',
          },
        ],
        lectures: null,
      },
    ],
  },
  instructors: [
    {
      id: '185939614',
      coursesTaught: 43,
      department: '',
      fullName: 'Professionals from the Industry',
      isTopInstructor: null,
      learnersReached: 13043,
      photo:
        'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/https://coursera-instructor-photos.s3.amazonaws.com/83/b4728947fa4257a6dcdd56b36db0b1/Screenshot-2025-06-25-at-2.41.43-PM-1-.jpg',
      shortName: '',
      title: '',
      website: null,
    },
  ],
};

export const mockVspPageQueryData = [courseOne, courseTwo, courseThree];
